import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

// Utils
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import ChatWidget from "@/components/ChatWidget";

// Layout
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import AirFreightPage from "@/pages/AirFreightPage";
import OceanFreightPage from "@/pages/OceanFreightPage";
import RoadFreightPage from "@/pages/RoadFreightPage";
import WarehousingPage from "@/pages/WarehousingPage";
import CustomsPage from "@/pages/CustomsPage";
import SectorsPage from "@/pages/SectorsPage";
import CargoTypesPage from "@/pages/CargoTypesPage";
import BlogPage from "@/pages/BlogPage";
import QuotePage from "@/pages/QuotePage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ResendVerificationPage from "@/pages/ResendVerificationPage";
import TrackingPage from "@/pages/TrackingPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import EquipmentPage from "@/pages/EquipmentPage";
import AdminDashboard from "@/pages/AdminDashboard";
import UserManagement from "@/pages/UserManagement";
import EquipmentManagement from "@/pages/EquipmentManagement";
import ClientPortal from "@/pages/ClientPortal";
import EmployeePortal from "@/pages/EmployeePortal";
// Legal Pages
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPage from "@/pages/CookiesPage";
import FAQPage from "@/pages/FAQPage";
import RoutesPage from "@/pages/RoutesPage";
import TariffConfigPage from "@/pages/TariffConfigPage";
import MetricsDashboardPage from "@/pages/MetricsDashboardPage";
import ContentManagementPage from "@/pages/ContentManagementPage";
import DocumentManagementPage from "@/pages/DocumentManagementPage";
import TrackingDashboardPage from "@/pages/TrackingDashboardPage";
import TrustCompliancePage from "@/pages/TrustCompliancePage";
import PartnersPage from "@/pages/PartnersPage";

// Context
import { AuthProvider } from "@/context/AuthContext";
import { ReCaptchaConfigProvider } from "@/components/ReCaptchaProvider";

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <ReCaptchaConfigProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/air-freight" element={<AirFreightPage />} />
              <Route path="/services/ocean-freight" element={<OceanFreightPage />} />
              <Route path="/services/road-freight" element={<RoadFreightPage />} />
              <Route path="/services/warehousing" element={<WarehousingPage />} />
              <Route path="/services/customs" element={<CustomsPage />} />
              <Route path="/sectors" element={<SectorsPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/cargo-types" element={<CargoTypesPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/quote" element={<QuotePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/tracking" element={<TrackingPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/equipment" element={<EquipmentPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/admin/equipment" element={<EquipmentManagement />} />
              {/* User Portals */}
              <Route path="/client-portal" element={<ClientPortal />} />
              <Route path="/employee-portal" element={<EmployeePortal />} />
              {/* Legal Pages */}
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/routes" element={<RoutesPage />} />
              <Route path="/admin/tariffs" element={<TariffConfigPage />} />
              <Route path="/admin/metrics" element={<MetricsDashboardPage />} />
              <Route path="/admin/content" element={<ContentManagementPage />} />
              <Route path="/documents" element={<DocumentManagementPage />} />
              <Route path="/tracking-dashboard" element={<TrackingDashboardPage />} />
              <Route path="/trust-compliance" element={<TrustCompliancePage />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <WhatsAppButton />
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
      </ReCaptchaConfigProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
